import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { ChevronRightIcon } from '@zep/icons';
import { Input, Radio } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { StoreMaximumPrice } from '../../../../consts';
import { StoreAppUploadDataType, StoreAssetUploadDataType } from '../../../../types/StoreTypes';
import S from './UploadPriceSet.module.scss';
const UploadPriceSet = (props: UploadPriceSetProps) => {
  const {
    commonForm,
    isEditable
  } = props;
  const {
    t
  } = useTranslation(['store']);
  const {
    register,
    getValues,
    setValue,
    clearErrors,
    control,
    watch,
    formState: {
      errors
    }
  } = commonForm as UseFormReturn<StoreAssetUploadDataType | StoreAppUploadDataType>;
  return <div className={S.upload_form_row} data-sentry-component="UploadPriceSet" data-sentry-source-file="UploadPriceSet.tsx">
      <label>{t('store:store_price')}</label>
      <label>
        <a href={t('store:store_zem_settlement_guide_link')} className={S.settlement_guide_link} target="_blank" rel="noreferrer">
          {t('store:store_zem_settlement_guide')}
          <ChevronRightIcon width={18} height={18} fill={Colors.PrimaryDefault} data-sentry-element="ChevronRightIcon" data-sentry-source-file="UploadPriceSet.tsx" />
        </a>
      </label>

      <div className={S.upload_form_cell}>
        <div className={S.price_radio_wrapper}>
          <Controller control={control} name="isFree" render={({
          field: {
            name,
            onChange,
            onBlur,
            value
          }
        }) => <>
                <Radio name={name} onChange={() => {
            setValue('price', 0);
            onChange(true);
          }} onBlur={onBlur} checked={value === true} label={t('store:store_asset_free')} disabled={isEditable} labelPlacement={'left'} />
                <Radio name={name} onChange={() => {
            setValue('price', 1);
            onChange(false);
          }} onBlur={onBlur} checked={value === false} label={t('store:store_asset_priced')} disabled={isEditable} labelPlacement={'left'} />
              </>} data-sentry-element="Controller" data-sentry-source-file="UploadPriceSet.tsx" />
        </div>
        <div className={S.price_input}>
          <Input type="number" inputMode="numeric" min={watch('isFree') ? 0 : 1} max={StoreMaximumPrice} step={1} isDisabled={watch('isFree') || isEditable} isFullWidth rightSlot={t('store:store_zem')} {...register('price', {
          valueAsNumber: true
        })} error={!!errors.price} onInput={event => setValue('price', +(event.target as HTMLInputElement).value.replace(/[^0-9]/g, ''))} onBlur={() => {
          const value = getValues('price');
          if (!value || value <= 0) {
            setValue('price', 1);
            clearErrors('price');
          }
        }} data-sentry-element="Input" data-sentry-source-file="UploadPriceSet.tsx" />
        </div>
      </div>
    </div>;
};
export default UploadPriceSet;
type UploadPriceSetProps = {
  commonForm?: UseFormReturn<StoreAssetUploadDataType> | UseFormReturn<StoreAppUploadDataType>;
  isEditable: boolean;
};